<template>
  <div class="frise-parcours">
    <p v-if="!lignes.length" class="frise-vide">Aucune étape enregistrée pour cette venue.</p>
    <ol v-else class="frise-liste">
      <li v-for="ligne in lignes" :key="ligne.cle" :class="['frise-' + ligne.type, ligne.type === 'attente' ? 'frise-niveau-' + ligne.niveau : '', { 'frise-en-cours': ligne.en_cours }]">
        <template v-if="ligne.type === 'etape'">
          <span class="frise-point" aria-hidden="true"></span>
          <div class="frise-contenu">
            <div class="frise-ligne">
              <strong class="frise-titre">{{ ligne.titre }}</strong>
              <span class="frise-heure">{{ ligne.heure }}<template v-if="ligne.fin"> → {{ ligne.fin }}</template></span>
              <span v-if="ligne.secondes !== null" class="frise-duree">{{ ligne.en_cours ? 'en cours · ' : '' }}{{ duree(ligne.secondes) }}</span>
            </div>
            <span v-if="ligne.detail" class="frise-detail">{{ ligne.detail }}</span>
            <span v-if="ligne.auteur" class="frise-auteur">{{ ligne.auteur }}</span>
          </div>
        </template>
        <template v-else>
          <span class="frise-trait" aria-hidden="true"></span>
          <span class="frise-attente-texte">{{ ligne.libelle }} · {{ ligne.en_cours ? 'depuis ' : '' }}{{ duree(ligne.secondes) }}</span>
        </template>
      </li>
    </ol>
  </div>
</template>

<script>
import { lignesFrise, duree } from './parcours-utils'

// Frise du parcours (04/10/2026) : étapes (points pleins) et attentes entre elles (traits pointillés, orange ou rouge).
export default {
  name: 'frise-parcours',
  props: {
    etapes: { type: Array, default: () => [] },
    position: { type: Object, default: null },
    maintenant: { type: Date, default: () => new Date() },
  },
  computed: {
    lignes() { return lignesFrise(this.etapes, this.position, this.maintenant) },
  },
  methods: { duree },
}
</script>

<style scoped>
.frise-liste { list-style: none; margin: 0; padding: 0 0 0 4px; }
.frise-liste li { position: relative; display: flex; gap: 14px; }
.frise-etape { padding: 6px 0; }
.frise-point { flex: none; width: 14px; height: 14px; margin-top: 4px; border-radius: 50%; background: #3b73f2; box-shadow: 0 0 0 4px #e3ecff; }
.frise-en-cours .frise-point { background: #1e8e5a; box-shadow: 0 0 0 4px #dcf3e7; }
.frise-contenu { display: flex; flex-direction: column; min-width: 0; }
.frise-ligne { display: flex; flex-wrap: wrap; align-items: baseline; gap: 4px 12px; }
.frise-titre { color: #22324f; font-size: 16px; }
.frise-heure { color: var(--ui-text-secondary, #65728b); font-variant-numeric: tabular-nums; }
.frise-duree { padding: 1px 8px; border-radius: 999px; background: #eef3fb; color: var(--ui-text, #304269); font-size: 13px; font-weight: 600; }
.frise-en-cours .frise-duree { background: #dcf3e7; color: #1e6b45; }
.frise-detail { color: var(--ui-text-secondary, #65728b); font-size: 13px; }
.frise-auteur { color: var(--ui-text, #4a5875); font-size: 13px; font-style: italic; }
.frise-attente { align-items: center; min-height: 34px; }
.frise-trait { flex: none; width: 14px; align-self: stretch; background: linear-gradient(#b8c6df 50%, transparent 0) center / 2px 8px repeat-y; }
.frise-attente-texte { color: var(--ui-text-secondary, #65728b); font-size: 13px; }
.frise-niveau-orange .frise-attente-texte { color: #b25e09; font-weight: 600; }
.frise-niveau-orange .frise-trait { background-image: linear-gradient(#f0a046 50%, transparent 0); }
.frise-niveau-rouge .frise-attente-texte { color: #b42318; font-weight: 600; }
.frise-niveau-rouge .frise-trait { background-image: linear-gradient(#e5484d 50%, transparent 0); }
.frise-vide { color: var(--ui-text-secondary, #65728b); }
</style>
